export class BaseSnackbarComponent {
    public message: string;

    constructor(data: any) {
        this.message = data.message;
    }
}
